import type React from 'react';
import type { View } from 'react-native';

type Layout = {
  x: number;
  y: number;
  width: number;
  height: number;
};

// Async/await wrapper around React-Native's measureLayout
export const measureLayoutAsync = (
  ref: React.RefObject<View>,
  relativeToNativeComponentRef: React.RefObject<View>
): Promise<Layout> =>
  new Promise((resolve, reject) => {
    if (!ref.current || !relativeToNativeComponentRef.current) {
      reject(new Error('Undefined ref'));
      return;
    }

    ref.current.measureLayout(
      relativeToNativeComponentRef.current as unknown as number, // weird type error here
      // eslint-disable-next-line max-params
      (x: number, y: number, width: number, height: number) => {
        resolve({ x, y, width, height });
      },
      reject
    );
  });
